import MultipleSelect from "../../../Components/CluppForms/MultipleSelect";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const ProcedureQuestion = ({ state, setState, field }) => {
  const options = [
    {
      id: `Placas`,
      label: `Placas`,
      value: `Placas`,
    },
    {
      id: "Corralón",
      label: "Corralón",
      value: "Corralón",
    },
    { id: "Otro", label: "Otro (escribe tu trámite)", value: "" },
  ];

  return (
    <>
      <TitleHeaders
        title={"¿Qué tipo de trámite?"}
        subtitle={"Por favor, selecciona una de las siguientes opciones."}
        isRequired={true}
      />

      <MultipleSelect
        options={options}
        state={state}
        setState={setState}
        field={field}
        isMultiple={false}
        haveOtherTextField={true}
      />
    </>
  );
};

export default ProcedureQuestion;
